/**
 * @generated SignedSource<<e6617e692d39bb3a996a691ad31f8543>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RemoveAttachmentsMutationInput = {
  clientMutationId?: string | null;
  ids: ReadonlyArray<string>;
};
export type PostDraftOtherRemoveMutation$variables = {
  input: RemoveAttachmentsMutationInput;
};
export type PostDraftOtherRemoveMutation$data = {
  readonly removeAttachments: {
    readonly __typename: "Attachments";
    readonly attachments: ReadonlyArray<{
      readonly id: string;
    }>;
  } | {
    readonly __typename: "RemoveAttachmentsError";
    readonly message: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
};
export type PostDraftOtherRemoveMutation = {
  response: PostDraftOtherRemoveMutation$data;
  variables: PostDraftOtherRemoveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": null,
    "kind": "LinkedField",
    "name": "removeAttachments",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Attachment",
            "kind": "LinkedField",
            "name": "attachments",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "type": "Attachments",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "type": "RemoveAttachmentsError",
        "abstractKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PostDraftOtherRemoveMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PostDraftOtherRemoveMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1c06134899abcc7a85de376d20ab4b1c",
    "id": null,
    "metadata": {},
    "name": "PostDraftOtherRemoveMutation",
    "operationKind": "mutation",
    "text": "mutation PostDraftOtherRemoveMutation(\n  $input: RemoveAttachmentsMutationInput!\n) {\n  removeAttachments(input: $input) {\n    __typename\n    ... on Attachments {\n      attachments {\n        id\n      }\n    }\n    ... on RemoveAttachmentsError {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "36052abf8cff35c4d8b532999e4d5252";

export default node;
